<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Open Document For Customer</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label for="documentTemplateInput">Document Template</label>
      <select class="custom-select" id="documentTemplateInput" name="documentTemplateInput"
              [(ngModel)]="selectedDocumentTemplate"
              [disabled]="loadingDocumentTemplates || (documentTemplateList.length === 0)">
        <option *ngFor="let documentTemplate of documentTemplateList"
                [ngValue]="documentTemplate">
          {{ documentTemplate.name }}
        </option>
          <option *ngIf="loadingDocumentTemplates"
                  [ngValue]="null"
                  selected>
            Loading...
          </option>
          <option *ngIf="!loadingDocumentTemplates && (documentTemplateList.length === 0)"
                  [ngValue]="null"
                  selected>
            No document templates are available
          </option>
      </select>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!isLoading()"
            [disabled]="selectedDocumentTemplate === null"
            [class.disabled]="selectedDocumentTemplate === null"
            (click)="handleSubmit()">
      Submit
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="isLoading()">
      Loading...
    </button>
  </div>

</ng-container>
